/**
* bootstrap-typeahead.js
* Copyright 2013 Twitter, Inc.
* http://www.apache.org/licenses/LICENSE-2.0.txt
*/
/* =============================================================
 * bootstrap-typeahead.js v2.3.2
 * http://getbootstrap.com/2.3.2/javascript.html#typeahead
 * =============================================================
 * Copyright 2013 Twitter, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ============================================================ */


!function ($) {

	"use strict"; // jshint ;_;


	/* TYPEAHEAD PUBLIC CLASS DEFINITION
	 * ================================= */

	var Typeahead = function (element, options) {
		this.$element = $(element)
		this.options = $.extend({}, $.fn.typeahead.defaults, options)
		this.matcher = this.options.matcher || this.matcher
		this.sorter = this.options.sorter || this.sorter
		this.highlighter = this.options.highlighter || this.highlighter
		this.updater = this.options.updater || this.updater
		this.source = this.options.source || $.map(this.$element[0].__msajaxbindings[0]._source.get_options(), function (val, i) { return val.get_displayValue(); }),
		this.$menu = $(this.options.menu)
		this.shown = false
		this.listen()
	}

	Typeahead.prototype = {

		constructor: Typeahead

	, select: function () {
		var val = this.$menu.find('.active').attr('data-value')
		this.$element
		  .val(this.updater(val))
		  .change()

		$simulateMutationEvent(this.$element.get(0), "change", false, true)

		return this.hide()
	}

	, updater: function (item) {
		return item
	}

	, show: function () {
		var pos = $.extend({}, this.$element.position(), {
			height: this.$element[0].offsetHeight
		})

		this.$menu
		  .insertAfter(this.$element)
		  .css({
			top: pos.top + pos.height
		  , left: pos.left
		  })
		  .show()

		var $pageContainer = this.$element.closest('.c-forms-pages')
		if ($pageContainer.length) {
			var currentHeight = this.$menu.get(0).offsetHeight
			var maxHeight = $pageContainer.get(0).offsetHeight - (pos.top + pos.height);
			if (currentHeight > maxHeight) {
				this.$menu.css({
					height: maxHeight
					, overflow: 'auto'
				})
			}
		}
		
		var $modal = this.$menu.closest('.c-modal.c-expression-builder-dialog--is-advanced');
		if($modal.length) {
			var menuInitialHeight = this.$menu.height();
			var menuNewHeight = ($modal.height() + $modal.offset().top) - this.$menu.offset().top;
			if(menuNewHeight < menuInitialHeight) {
				this.$menu.css({
					height: menuNewHeight
				});
			}
		}
		
		this.shown = true
		return this
	}

	, hide: function () {
		this.$menu.hide()
		this.shown = false
		return this
	}

	, lookup: function (event) {
		var items

		this.query = this.$element.val()

		if (!this.query || this.query.length < this.options.minLength) {
			return this.shown ? this.hide() : this
		}

		items = $.isFunction(this.source) ? this.source(this.query, $.proxy(this.process, this)) : this.source

		return items ? this.process(items) : this
	}

	, process: function (items) {
		var that = this

		items = $.grep(items, function (item) {
			return that.matcher(item)
		})

		items = this.sorter(items)

		if (!items.length) {
			return this.shown ? this.hide() : this
		}

		return this.render(items.slice(0, this.options.items)).show()
	}

	, matcher: function (item) {
		return ~item.toLowerCase().indexOf(this.query.toLowerCase())
	}

	, sorter: function (items) {
		var beginswith = []
		  , caseSensitive = []
		  , caseInsensitive = []
		  , item

		while (item = items.shift()) {
			if (!item.toLowerCase().indexOf(this.query.toLowerCase())) beginswith.push(item)
			else if (~item.indexOf(this.query)) caseSensitive.push(item)
			else caseInsensitive.push(item)
		}

		return beginswith.concat(caseSensitive, caseInsensitive)
	}

	, highlighter: function (item) {
		var query = this.query.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, '\\$&')
		return item.replace(new RegExp('(' + query + ')', 'ig'), function ($1, match) {
			return '<strong>' + match + '</strong>'
		})
	}

	, render: function (items) {
		var that = this

		items = $(items).map(function (i, item) {
			i = $(that.options.item).attr('data-value', item)
			i.find('a').html(that.highlighter(item))
			return i[0]
		})
		items.first().addClass('active')
		this.$menu.html(items)
		return this
	}

	, next: function (event) {
		var active = this.$menu.find('.active').removeClass('active')
		  , next = active.next()

		if (!next.length) {
			next = $(this.$menu.find('li')[0])
		}

		next.addClass('active')
		
		var index = parseInt(next.attr('data-index'));
		var liPos = (index + 1) * 26;
		if (index == 0)
			this.$menu.scrollTop(0);
		else if (liPos > this.$menu.height()+this.$menu.scrollTop())
			this.$menu.scrollTop(liPos - this.$menu.height());
	}

	, prev: function (event) {
		var active = this.$menu.find('.active').removeClass('active')
		  , prev = active.prev()
		var isLast = false;

		if (!prev.length) {
			prev = this.$menu.find('li').last()
			isLast = true;
		}

		prev.addClass('active')

		var index = parseInt(prev.attr('data-index'));
		var liPos = index * 26;
		if (isLast)
			this.$menu.scrollTop(liPos);
		else if (liPos < this.$menu.scrollTop())
			this.$menu.scrollTop(liPos);
	}

	, listen: function () {
		this.$element
		  .on('focus', $.proxy(this.focus, this))
		  .on('blur', $.proxy(this.blur, this))
		  .on('keyup', $.proxy(this.keyup, this))

		if (this.eventSupported('keydown')) {
			this.$element.on('keydown', $.proxy(this.keydown, this))
		}

		this.$menu
		  .on('click', $.proxy(this.click, this))
		  .on('mouseenter', 'li', $.proxy(this.mouseenter, this))
		  .on('mouseleave', 'li', $.proxy(this.mouseleave, this))
		  .on('mouseenter', $.proxy(this.mouseentermenu, this))
		  .on('mouseleave', $.proxy(this.mouseleavemenu, this))
		  .on('mouseup', $.proxy(this.mouseup, this))
	}

	, eventSupported: function (eventName) {
		var isSupported = eventName in this.$element
		if (!isSupported) {
			this.$element.setAttribute(eventName, 'return;')
			isSupported = typeof this.$element[eventName] === 'function'
		}
		return isSupported
	}

	, move: function (e) {
		if (!this.shown) return

		switch (e.keyCode) {
			case 9: // tab
			case 13: // enter
			case 27: // escape
				e.preventDefault()
				break

			case 38: // up arrow
				e.preventDefault()
				this.prev()
				break

			case 40: // down arrow
				e.preventDefault()
				this.next()
				break
		}

		e.stopPropagation()
	}

	, keydown: function (e) {
		this.suppressKeyPressRepeat = ~$.inArray(e.keyCode, [40, 38, 9, 13, 27])
		this.move(e)
	}

	, keyup: function (e) {
		switch (e.keyCode) {
			case 40: // down arrow
			case 38: // up arrow
			case 16: // shift
			case 17: // ctrl
			case 18: // alt
				break

			case 9: // tab
			case 13: // enter
				if (!this.shown) return
				this.select()
				break

			case 27: // escape
				if (!this.shown) return
				this.hide()
				break

			default:
				this.lookup()
		}

		e.stopPropagation()
		e.preventDefault()
	}

	, focus: function (e) {
		this.focused = true
	}

	, blur: function (e) {
		this.focused = false
		if (!this.mousedovermenu && this.shown) this.hide()
	}

	, click: function (e) {
		e.stopPropagation()
		e.preventDefault()
		this.select()
		this.$element.focus()
	}

	, mouseenter: function (e) {
		this.mousedover = true
		this.$menu.find('.active').removeClass('active')
		$(e.currentTarget).addClass('active')
	}

	, mouseleave: function (e) {
		this.mousedover = false
	}

	, mouseentermenu: function (e) {
		this.mousedovermenu = true
	}

	, mouseleavemenu: function (e) {
		this.mousedovermenu = false
	}

	, mouseup: function (e) {
		var selectedElement = this.$menu.find('.active')
		if (this.mousedovermenu && !this.mousedover) {
			this.focusItem = selectedElement
			this.$element.focus()
		}
	}

	}


	/* TYPEAHEAD PLUGIN DEFINITION
	 * =========================== */

	var old = $.fn.typeahead

	$.fn.typeahead = function (option) {
		return this.each(function () {
			var $this = $(this)
			  , data = $this.data('typeahead')
			  , options = typeof option == 'object' && option
			if (!data) $this.data('typeahead', (data = new Typeahead(this, options)))
			if (typeof option == 'string') data[option]()
		})
	}

	$.fn.typeahead.defaults = {
		source: []
	, items: 8
	, menu: '<ul class="typeahead dropdown-menu scrollbar"></ul>'
	, item: '<li><a href="#"></a></li>'
	, minLength: 1
	}

	$.fn.typeahead.Constructor = Typeahead


	/* TYPEAHEAD NO CONFLICT
	 * =================== */

	$.fn.typeahead.noConflict = function () {
		$.fn.typeahead = old
		return this
	}


	/* TYPEAHEAD DATA-API
	 * ================== */

	$(document).on('focus.typeahead.data-api', '[data-provide="typeahead"]', function (e) {
		var $this = $(this)
		if ($this.data('typeahead')) return
		$this.typeahead($this.data())
	})

}(jQuery);

/* =============================================================
 * bootstrap-better-typeahead.js v1.0.0 by Philipp Nolte
 * https://github.com/ptnplanet/Bootstrap-Better-Typeahead
 * =============================================================
 * This plugin makes use of twitter bootstrap typeahead
 * http://twitter.github.com/bootstrap/javascript.html#typeahead
 *
 * Bootstrap is licensed under the Apache License, Version 2.0
 * http://www.apache.org/licenses/LICENSE-2.0
 * ============================================================ */

!function($) {

	"use strict";

	/**
	 * The better typeahead plugin will extend the bootstrap typeahead plugin and provide the ability to set the
	 * minLength option to zero. The tab keyup event handler had to be moved to the keydown event handler, so that
	 * the full list of available items is shown on tab-focus and the original behaviour is preserved as best as
	 * possible.
	 *
	 * @type {object}
	 */
	var BetterTypeahead = {

		lookup: function(event) {
			var items;

			// Now supports empty queries (eg. with a length of 0).
			this.query = this.$element.val() || '';

			if (this.query.length < this.options.minLength) {
				return this.shown ? this.hide() : this;
			}

			items = $.isFunction(this.source) ? this.source(this.query, $.proxy(this.process, this)) : this.source;

			return items ? this.process(items) : this;
		}

		, process: function (items) {
			var that = this;

			items = $.grep(items, function (item) {
				return that.matcher(item);
			});

			items = this.sorter(items);

			if (!items.length) {
				return this.shown ? this.hide() : this;
			}

			if (this.query.length) {
				items = items.slice(0, this.options.items);
			}
			if (this.focusItem) {
				this.focusItem = null;
				return;
			}
			return this.render(items).show();
		}

		, render: function (items) {
			var that = this

			items = $(items).map(function (i, item) {
				var li = $(that.options.item).attr('data-value', item);
				li.attr('data-index', i);
				li.find('a').html(that.highlighter(item));
				return li[0];
			});

			if (this.query.length > 0) {
				if (this.focusItem)
					return;
				else
					items.first().addClass('active');
			}

			this.$menu.html(items);
			return this;
		}

		, move: function (e) {
			if (!this.shown) return;

			switch (e.keyCode) {
				case 9: // tab
				case 13: // enter
					if (this.options.useTabToSelect === true)
						e.preventDefault();
					else if (this.shown) {
                        this.select()
						this.hide();
					}
					break;
				case 27: // escape
					e.preventDefault();
					break;

				case 38: // up arrow
					e.preventDefault();
					this.prev();
					e.stopPropagation();
					break;

				case 40: // down arrow
					e.preventDefault();
					this.next();
					e.stopPropagation();
					break;
			}
		}

		, keydown: function (e) {
			this.suppressKeyPressRepeat = ~$.inArray(e.keyCode, [40,38,9,13,27]);
			this.move(e);
		}

		, keyup: function (e) {
			switch(e.keyCode) {
			    case 37: // left
			    case 39: // right
			        return;
				case 40: // down arrow
				case 38: // up arrow
				case 16: // shift
				case 17: // ctrl
				case 18: // alt
					break;

				case 13: // enter
				case 9: // tab
					if (!this.shown) return;
					this.select();
					this.show();
					break;

				case 27: // escape;
					if (!this.shown) return;
					this.hide();
					break;

				default:
					this.lookup();
			}

			//if (!this.options.useTabToSelect)
            e.stopPropagation();
			e.preventDefault();
		}

		, focus: function(e) {
			this.focused = true;

			if (!this.mousedover) {
				this.lookup(e);
			}
		}
	};

	$.extend($.fn.typeahead.Constructor.prototype, BetterTypeahead);

}(jQuery);